import { render, staticRenderFns } from "./Questionary.vue?vue&type=template&id=b3a3fdca"
import script from "./Questionary.vue?vue&type=script&lang=ts"
export * from "./Questionary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports